import { render, staticRenderFns } from "./PantryCategoryList.vue?vue&type=template&id=748ed199&scoped=true&"
import script from "./PantryCategoryList.vue?vue&type=script&lang=ts&"
export * from "./PantryCategoryList.vue?vue&type=script&lang=ts&"
import style0 from "./PantryCategoryList.vue?vue&type=style&index=0&id=748ed199&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ed199",
  null
  
)

export default component.exports